import {
    JustpayPaymentSystemEndpointService
} from "@/views/loyalty/shared/endpoint_services/justpay-paymentsystem-endpoint-service"

export class JustpayPaymentSystemService {
    constructor () {
        this.justpayPaymentSystemEndpointService = new JustpayPaymentSystemEndpointService()
    }

    async createPayment (createPaymentRequest) {
        return this.justpayPaymentSystemEndpointService.createPayment(createPaymentRequest)
    }

    async getEntities (pointId) {
        return this.justpayPaymentSystemEndpointService.getEntities(pointId)
    }

    async getQrcode (id) {
        return this.justpayPaymentSystemEndpointService.getQrcode(id)
    }

    async getPaymentByIdempotency (idempotency) {
        return this.justpayPaymentSystemEndpointService.getPaymentByIdempotency(idempotency)
    }
}
